import {
    DEALERDSRMAPPINGLIST_FAILED,
    DEALERDSRMAPPINGLIST_SUCCESS,
    RESET_DEALERDSRMAPPINGLIST,
    LOADING_DEALERDSRMAPPINGLIST,
    NETWORK_ERROR_DEALERDSRMAPPINGLIST
} from '../types/index'

import { dealerServices } from "../../config/axios";
const resetDealerDsrMappingList = () => {
    return { type: RESET_DEALERDSRMAPPINGLIST };
};

const dealerDsrMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERDSRMAPPINGLIST });
    await dealerServices
        .post("dsrMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerDsrMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerDsrMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERDSRMAPPINGLIST,
                payload: err
            });
        });
};

function dealerDsrMappingListsuccess(data) {
    return {
        type: DEALERDSRMAPPINGLIST_SUCCESS,
        payload: data
    }
}

function dealerDsrMappingListFailed(data) {
    return {
        type: DEALERDSRMAPPINGLIST_FAILED,
        payload: data
    }
}

export { resetDealerDsrMappingList, dealerDsrMappingList }